module.exports = __webpack_public_path__ + "img/dollar.7dc07730.svg";